import { Outlet, Route } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";
import { featureFlagRoute } from "@/shared/routing/featureFlagRoute";

import { SessionsList } from "./SessionsList";

/**
 * Route tree for `/sessions`. The pathless parent preloads the user's
 * saved table preferences; the inner route gates render on the
 * `release-sessions` flag and redirects to `/search` when it is off.
 *
 * Spread into the top-level route list (`{...SessionsRoutes()}`) — the
 * inner `featureFlagRoute` already binds the absolute path.
 */
export const SessionsRoutes = () => [
  <Route
    key="sessions-preferences-layout"
    loader={loadSearchTablePreferences(
      queryClient,
      "session_search_table_preferences",
    )}
    element={<Outlet />}
  >
    {featureFlagRoute({
      path: "/sessions",
      flagName: "release-sessions",
      redirectTo: "/search",
      element: <SessionsList />,
    })}
  </Route>,
];
